export interface MarketFeedMeta {
    mode: 'delayed' | 'close';
    delaySeconds: number | null;
    sourceAt: string;
}

export interface MarketFeedResult {
    rows: any[];
    meta: MarketFeedMeta;
}

export function isSaudiMarketOpen(now = new Date()): boolean {
    try {
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Riyadh', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit' }).formatToParts(now);
        let wd = '';
        let h = 0;
        let m = 0;
        parts.forEach((p) => {
            if (p.type === 'weekday') wd = p.value;
            if (p.type === 'hour') h = parseInt(p.value, 10) % 24;
            if (p.type === 'minute') m = parseInt(p.value, 10);
        });
        if (wd === 'Fri' || wd === 'Sat') return false;
        const mins = h * 60 + m;
        return mins >= 600 && mins < 930;
    } catch {
        return false;
    }
}

export function riyadhTime(value: string): string {
    const raw = String(value || '').trim();
    if (!raw) return '';
    // «2026-10-28 15:59:42» و«15:59» بتوقيت الرياض أصلاً — بلا تحويل
    const plain = raw.match(/(\d{2}):(\d{2})(?::\d{2})?$/);
    if (plain && !/[TZ]/.test(raw) && !/GMT|UTC/i.test(raw)) return `${plain[1]}:${plain[2]}`;
    const d = new Date(raw);
    if (isNaN(d.getTime())) return plain ? `${plain[1]}:${plain[2]}` : '';
    return new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Riyadh', hour12: false, hour: '2-digit', minute: '2-digit' }).format(d);
}

// الموقع العام لا يتصل إلا بدالة /api/live-data التي تحجب البيانات اللحظية أثناء الجلسة
export async function fetchMarketFeed(): Promise<MarketFeedResult> {
    const res = await fetch(`/api/live-data?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) throw new Error(`feed ${res.status}`);
    const rows = await res.json();
    if (!Array.isArray(rows) || rows.length === 0) throw new Error('feed empty');
    const mode: 'delayed' | 'close' = res.headers.get('X-Data-Mode') === 'delayed' ? 'delayed' : 'close';
    return {
        rows,
        meta: {
            mode,
            delaySeconds: Number(res.headers.get('X-Delay-Seconds')) || null,
            sourceAt: res.headers.get('X-Source-At') || String(rows[0]?._scraped_at || ''),
        },
    };
}
